import { slicedToArray as _slicedToArray, extends as _extends, toConsumableArray as _toConsumableArray, asyncToGenerator as _asyncToGenerator, regenerator as _regenerator } from '../../_virtual/_rollupPluginBabelHelpers.js';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { Button } from '../Button/index.js';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { ConfirmationModal } from '../ConfirmationModal/index.js';
import { SplitFileName } from '../../utils/StringUtil.js';
import React, { useState } from 'react';
import { i18n } from '../../i18n/translate.js';
import { FAIcon } from '../fa-icon/component.js';
import { pickDataAttributes } from '../../utils/pickDataAttributes.js';
var FileUpload = function FileUpload(props) {
  var _description$textArra, _button$dataAttribute;
  var fileInput = React.useRef(null);
  var _props$accept = props.accept,
    accept = _props$accept === void 0 ? ['*'] : _props$accept,
    _props$button = props.button,
    button = _props$button === void 0 ? {
      className: 'btn btn-primary'
    } : _props$button,
    _props$description = props.description,
    description = _props$description === void 0 ? {
      textArray: [],
      className: 'file-upload-description'
    } : _props$description,
    _props$header = props.header,
    header = _props$header === void 0 ? {
      className: 'file-upload-header'
    } : _props$header,
    _props$icon = props.icon,
    icon = _props$icon === void 0 ? {
      fileClassName: '',
      noFileClassName: ''
    } : _props$icon,
    instructionalText = props.instructionalText,
    label = props.label,
    _props$multiple = props.multiple,
    multiple = _props$multiple === void 0 ? false : _props$multiple,
    saveButton = props.saveButton,
    templateBtn = props.templateBtn,
    tooltip = props.tooltip,
    _props$border = props.border,
    border = _props$border === void 0 ? true : _props$border;
  var _useState = useState(props.files || []),
    _useState2 = _slicedToArray(_useState, 2),
    files = _useState2[0],
    setFiles = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    removed = _useState4[0],
    setRemoved = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showDeleteModal = _useState6[0],
    setShowDeleteModal = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    progress = _useState8[0],
    setProgress = _useState8[1];
  var _useState9 = useState(),
    _useState0 = _slicedToArray(_useState9, 2),
    previewSrc = _useState0[0],
    setPreviewSrc = _useState0[1];
  var getPreviewSrc = function getPreviewSrc(file) {
    var _file$type;
    if (multiple) return null;
    return ((_file$type = file.type) === null || _file$type === void 0 ? void 0 : _file$type.includes('image')) && window.URL.createObjectURL(file);
  };
  var addFiles = function addFiles(e) {
    var files = Array.from(e.currentTarget.files);
    if (!validateFiles(files)) {
      props.actions.failure({
        message: i18n.t('Cannot save file: incorrect file type')
      });
      return;
    }
    setRemoved([]);
    if (files) {
      setFiles(files);
    }
    setPreviewSrc(getPreviewSrc(e.currentTarget.files[0]));
    if (props.onUpload) {
      var _files = activeFiles();
      props.onUpload(_files);
    } else if (!saveButton) {
      save();
    }
  };
  var removeFile = function removeFile(name) {
    return function () {
      if (!removed.includes(name)) {
        setRemoved([].concat(_toConsumableArray(removed), [name]));
      }
      if (fileInput !== undefined) {
        setFiles(activeFiles());
      }
    };
  };
  var activeFiles = function activeFiles() {
    return Array.from(fileInput.current.files).filter(function (file) {
      return !removed.includes(file.name);
    });
  };
  var openFileDialogue = function openFileDialogue(e) {
    e.preventDefault();
    if (fileInput !== undefined) {
      fileInput.current.click();
      fileInput.current.dispatchEvent(new Event('input', {
        bubbles: true
      }));
    }
  };
  var validateFiles = function validateFiles(files) {
    var MIMEtypes = (accept || []).map(function (type) {
      return new RegExp(type.trim().replace('*', '[^\\/,]+'));
    });
    return files.every(function (file) {
      var fileType = file.type || SplitFileName(file.name).extension;
      return MIMEtypes.some(function (MIMEtype) {
        return MIMEtype.test(fileType);
      });
    });
  };
  var save = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator().m(function _callee() {
      var files, response, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            files = activeFiles();
            if (validateFiles(files)) {
              _context.n = 1;
              break;
            }
            props.actions.failure({
              message: i18n.t('Cannot save file: incorrect file type')
            });
            return _context.a(2);
          case 1:
            response = null;
            _context.p = 2;
            fileInput.current.setCustomValidity('File is uploading!');
            onUploadProgress(0, 100, false);
            _context.n = 3;
            return props.uploader(files, props.url, props.parameters, onUploadProgress, props.authToken);
          case 3:
            response = _context.v;
            if (response && props.actions && props.actions.success) {
              onUploadProgress(100, 100, true);
              props.actions.success(response);
            }
            _context.n = 5;
            break;
          case 4:
            _context.p = 4;
            _t = _context.v;
            fileInput.current.setCustomValidity('File upload failed!');
            if (props.actions && props.actions.failure) {
              props.actions.failure(_t.errors ? {
                message: _t.errors.map(function (error) {
                  return error.detail;
                }).join(',')
              } : _t);
            }
          case 5:
            return _context.a(2);
        }
      }, _callee, null, [[2, 4]]);
    }));
    return function save() {
      return _ref.apply(this, arguments);
    };
  }();
  var onUploadProgress = function onUploadProgress(current, total, complete) {
    if (total && total > 0) {
      if (fileInput && complete) {
        fileInput.current.setCustomValidity('');
      }
      setProgress({
        current: current,
        total: total,
        percentage: current / total * 100,
        complete: complete
      });
    }
  };
  var deleteFile = function deleteFile() {
    setShowDeleteModal(true);
  };
  var confirmDelete = function confirmDelete() {
    var name = props.name;
    if (typeof props.actions["delete"] === 'function' && name) {
      props.actions["delete"](name);
      if (previewSrc) {
        window.URL.revokeObjectURL(previewSrc);
      }
    }
    cancelDelete();
  };
  var cancelDelete = function cancelDelete() {
    setShowDeleteModal(false);
  };
  var createButtonClass = function createButtonClass(cls) {
    return "ui-default ".concat(cls || 'btn btn-success');
  };
  var previewUrl = props.embedPreviewUrl || previewSrc;
  var dataAttributes = pickDataAttributes(props);
  var fileUploadIcon = files.length > 0 ? icon.fileClassName : icon.noFileClassName;
  var fileUploadAdditionalClasses = files.length > 0 ? 'icon-file' : 'icon-no-file';
  return /*#__PURE__*/React.createElement("div", _extends({
    className: "".concat(props.className, " file-upload ").concat(border && 'file-upload-border')
  }, dataAttributes), !!header && /*#__PURE__*/React.createElement("h4", {
    className: header.className
  }, header.text || i18n.t('File Upload'), ' ', tooltip && /*#__PURE__*/React.createElement("span", {
    className: "tooltip-container"
  }, /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "top",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-"
    }, tooltip)
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FAIcon, {
    icon: "circle-question"
  }))))), instructionalText && /*#__PURE__*/React.createElement("div", {
    className: "instructional-text"
  }, instructionalText), description && /*#__PURE__*/React.createElement("p", {
    className: description.className
  }, (_description$textArra = description.textArray) === null || _description$textArra === void 0 ? void 0 : _description$textArra.map(function (desc) {
    return /*#__PURE__*/React.createElement("span", {
      key: desc
    }, desc, " ", /*#__PURE__*/React.createElement("br", null));
  })), /*#__PURE__*/React.createElement("input", {
    required: props.required,
    type: "file",
    ref: fileInput,
    onChange: addFiles,
    style: {
      display: 'none'
    },
    multiple: multiple,
    accept: (accept || []).join(',')
  }), /*#__PURE__*/React.createElement("div", {
    className: "file-upload-icon-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "file-upload-icon"
  }, /*#__PURE__*/React.createElement(FAIcon, {
    icon: fileUploadIcon,
    size: icon.iconSize,
    additionalClasses: fileUploadAdditionalClasses
  })), /*#__PURE__*/React.createElement("div", {
    className: "file-upload-label"
  }, files.length > 0 ? files.map(function (f) {
    return /*#__PURE__*/React.createElement("div", {
      key: f.name,
      className: "file-upload-label-container"
    }, f.name || i18n.t('No File'), ' ', (label === null || label === void 0 ? void 0 : label.closable) && /*#__PURE__*/React.createElement(FAIcon, {
      icon: "xmark",
      onClick: removeFile(f.name)
    }));
  }) : /*#__PURE__*/React.createElement("div", {
    className: "file-upload-label-container"
  }, (label === null || label === void 0 ? void 0 : label.text) || i18n.t('No File'), ' ', (label === null || label === void 0 ? void 0 : label.closable) && /*#__PURE__*/React.createElement(FAIcon, {
    icon: "xmark",
    onClick: removeFile(label.text)
  }))), progress ? /*#__PURE__*/React.createElement(ProgressBar, {
    now: progress.percentage
  }) : null), previewUrl && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: previewUrl,
    width: "230px"
  })), /*#__PURE__*/React.createElement("div", {
    className: "btn-group"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Button, _extends({}, button === null || button === void 0 ? void 0 : button.dataAttributes, {
    className: createButtonClass((button === null || button === void 0 ? void 0 : button.className) || ''),
    "data-action": (button === null || button === void 0 || (_button$dataAttribute = button.dataAttributes) === null || _button$dataAttribute === void 0 ? void 0 : _button$dataAttribute['data-action']) || 'choose-a-file',
    onClick: openFileDialogue,
    label: button.text || i18n.t('Browse'),
    icon: "cloud-arrow-up",
    style: "primary"
  }))), props.deleteButton && /*#__PURE__*/React.createElement("span", {
    className: "file-upload-delete"
  }, /*#__PURE__*/React.createElement("a", _extends({}, props.deleteButtonDataAttributes, {
    onClick: deleteFile
  }), /*#__PURE__*/React.createElement(FAIcon, {
    icon: "trash"
  }), i18n.t('Delete'))), !!templateBtn && Object.keys(templateBtn).length && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Button, _extends({}, pickDataAttributes(templateBtn), {
    className: createButtonClass('btn-secondary'),
    href: templateBtn.href,
    label: templateBtn.buttonLabel,
    icon: "down-to-line",
    style: "primary"
  })))), !!saveButton && /*#__PURE__*/React.createElement(Button, {
    label: i18n.t('Save'),
    style: "primary",
    onClick: save,
    className: createButtonClass(saveButton === null || saveButton === void 0 ? void 0 : saveButton.className)
  }), /*#__PURE__*/React.createElement(ConfirmationModal, {
    title: i18n.t('Delete this file?'),
    show: showDeleteModal,
    onCancel: cancelDelete,
    onConfirm: confirmDelete
  }, i18n.t('Are you sure you want to delete this file?')));
};
FileUpload.displayName = "FileUpload";
export { FileUpload };